import api from '@/api'
import types from '@/types'
import Report, { UnsupportedMediaTypeReport } from '@/api/communique/report'

export interface BroadcastDelivery {
  // the number of impressions for a specific device
  allimpressions: number

  ordered_impressions: number

  over_delivery: number

  over_delivery_percentage: number

  // the type of the device
  stations: String
}

export interface FetchBroadcastDeliveryParams {
  startDate?: string
  endDate?: string
  companyId?: string
  mediaTypes: string[]
  excludedInitiativeIDs?: string[]
  includedInitiativeIDs?: string[]
  station: String[] | null
}

export class CompanyBroadcastDelivery {
  public async fetchAll({
    companyId,
    mediaTypes,
    endDate,
    excludedInitiativeIDs,
    includedInitiativeIDs,
    startDate,
    station,
  }: FetchBroadcastDeliveryParams): Promise<Report<BroadcastDelivery> | UnsupportedMediaTypeReport> {
    return api('report.dashboards.ihmCompany.companyBroadcastDelivery')
      .params({
        companyId: companyId,
        media_types: mediaTypes,
        end_date: endDate,
        start_date: startDate,
        exclude_initiative_ids: excludedInitiativeIDs,
        include_initiative_ids: includedInitiativeIDs,
        station: station,
      })
      .cache(1000 * types.config.dashboardCacheSeconds())
      .jsonMust<Report<BroadcastDelivery>>()
  }
}
